/* OP Luxury 2026 - colourway swatches on product cards.
   Delegated listeners so cards injected by facets or quick add work too.
   No dependencies. Does nothing on pages without swatches. */
(function () {
  var WIDTHS = [360, 533, 720];
  var RX = /([?&])width=\d+/;

  function buildSrcset(url) {
    if (!RX.test(url)) return '';
    return WIDTHS.map(function (w) {
      return url.replace(RX, '$1width=' + w) + ' ' + w + 'w';
    }).join(', ');
  }

  function cardOf(row) {
    var wrap = row.closest('.card-wrapper');
    if (!wrap) return null;
    return { wrap: wrap, img: wrap.querySelector('.card__media .media img') };
  }

  function mark(row, active) {
    var all = row.querySelectorAll('.op-swatch');
    for (var i = 0; i < all.length; i++) {
      if (all[i] === active) all[i].classList.add('is-active');
      else all[i].classList.remove('is-active');
    }
  }

  function apply(swatch) {
    var row = swatch.closest('.op-swatches');
    if (!row) return;
    var card = cardOf(row);
    if (!card || !card.img) return;
    var url = swatch.getAttribute('data-op-img');
    if (!url) return;
    var img = card.img;
    if (img.dataset.opSrc === undefined) {
      img.dataset.opSrc = img.getAttribute('src') || '';
      img.dataset.opSrcset = img.getAttribute('srcset') || '';
    }
    var ss = buildSrcset(url);
    if (ss) img.setAttribute('srcset', ss);
    else img.removeAttribute('srcset');
    img.setAttribute('src', url);
    card.wrap.classList.add('op-swatched');
    mark(row, swatch);
  }

  function restore(row) {
    var card = cardOf(row);
    if (!card) return;
    var img = card.img;
    if (img && img.dataset.opSrc !== undefined) {
      if (img.dataset.opSrcset) img.setAttribute('srcset', img.dataset.opSrcset);
      else img.removeAttribute('srcset');
      img.setAttribute('src', img.dataset.opSrc);
    }
    card.wrap.classList.remove('op-swatched');
    mark(row, null);
  }

  function swatchFrom(event) {
    var node = event.target;
    return node && node.closest ? node.closest('.op-swatch[data-op-img]') : null;
  }

  document.addEventListener('mouseover', function (event) {
    var swatch = swatchFrom(event);
    if (swatch) apply(swatch);
  });

  document.addEventListener('mouseout', function (event) {
    var node = event.target;
    var row = node && node.closest ? node.closest('.op-swatches') : null;
    if (!row || row.hasAttribute('data-op-pinned')) return;
    if (event.relatedTarget && row.contains(event.relatedTarget)) return;
    restore(row);
  });

  document.addEventListener(
    'click',
    function (event) {
      var swatch = swatchFrom(event);
      if (!swatch) return;
      event.preventDefault();
      event.stopPropagation();
      var row = swatch.closest('.op-swatches');
      if (row) row.setAttribute('data-op-pinned', '');
      apply(swatch);
    },
    true
  );

  /* Product page colourway chips. The chip carries the photograph; the name
     of the chosen colourway is written next to the option label, because
     "Solid grey lenses with black Etruscan marble frame" will not fit inside
     a 90px chip and the shopper still needs to be told what they picked.

     Nothing else about the variant change is touched: this listens after the
     fact and only writes text. */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('.op-cw input[type="radio"]')) return;
    var field = input.closest('.op-cw');
    if (!field) return;
    var name = field.querySelector('[data-op-cw-name]');
    if (name) name.textContent = input.value;
  });
})();